export default __webpack_public_path__ + "/assets/text-03.png";